import React from "react";
import ReactDOM from "react-dom/client";
import BeatFinder from "./BeatFinder";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<BeatFinder />);
